import { render, staticRenderFns } from "./permisos.vue?vue&type=template&id=519e8e26&"
import script from "./permisos.vue?vue&type=script&lang=ts&"
export * from "./permisos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports